module.exports = __webpack_public_path__ + "img/iaoshe.dd730ba4.png";